module.exports = __webpack_public_path__ + "static/media/Layout26.5970f768.png";